import React from 'react'
import { useTranslation } from 'react-i18next'
import Text from '@navent-jobs/ui-kit/components/text'
import { NOMBRE_SITIO } from '../../../../constants'
import { Legales } from './mixins'

const Component = () => {
  const { t } = useTranslation()
  const nombreSitio = NOMBRE_SITIO

  return (
    <Legales>
      <Text size="xs">
        {t('fichaAviso.legales', { nombreSitio })}
        <Text size="xs" fontWeight="semibold" as="span">
          {` ${t('legales.advertenciaPagos')} `}
        </Text>
        {t('legales.advertenciaPagosReclutador')}
      </Text>
    </Legales>
  )
}

export default Component
